var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83433 11.7656C5.68435 11.6156 5.6001 11.4121 5.6001 11.2C5.6001 10.9879 5.68435 10.7844 5.83433 10.6344L8.46873 8L5.83433 5.3656C5.6886 5.21471 5.60796 5.01263 5.60979 4.80288C5.61161 4.59312 5.69575 4.39247 5.84407 4.24414C5.9924 4.09581 6.19305 4.01168 6.40281 4.00986C6.61256 4.00803 6.81464 4.08867 6.96553 4.2344L10.1655 7.4344C10.3155 7.58442 10.3998 7.78786 10.3998 8C10.3998 8.21213 10.3155 8.41557 10.1655 8.5656L6.96553 11.7656C6.8155 11.9156 6.61206 11.9998 6.39993 11.9998C6.1878 11.9998 5.98435 11.9156 5.83433 11.7656Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.6c0fe2fe27ebd0f4a66c39f2962ba34e.svg";
export { ForwardRef as ReactComponent };